import { ActionFactoryParams } from '../../../../utilsDeprecated/ControlledComponent/ControlledComponent.types';
import { CalendarStateDeprecated } from '../../controller';
import { CalendarContext } from '../../../../utilsDeprecated/context/contextFactory';
import { WidgetElements } from '../../../../utilsDeprecated/bi/consts';
import { bookingsUouFlowCalendarElementLoaded } from '@wix/bi-logger-wixboost-ugc/v2';

export type OnElementLoaded = (
  element: WidgetElements,
  rawProperties?: any,
) => void;

export const createOnElementLoaded =
  ({
    context: { biLogger },
  }: ActionFactoryParams<CalendarStateDeprecated, CalendarContext>): OnElementLoaded =>
  (element, rawProperties) => {
    let value;

    if (rawProperties) {
      if (typeof rawProperties === 'object') {
        value = JSON.stringify(rawProperties);
      } else {
        value = rawProperties.toString();
      }
    }

    biLogger.report(
      bookingsUouFlowCalendarElementLoaded({
        element,
        value,
      }),
    );
  };
